module.exports = __webpack_public_path__ + "img/Professional-3.af8eaf3e.gif";